module.exports = __webpack_public_path__ + "img/jola-3d.3050d1c5.png";